export default function OttChannels() {

  const categories = {
    "OTT Apps": [
      "netflix.jpeg","appletv.jpeg","altt.jpeg","jiocinema.jpeg",
      "jiohotstar.jpeg","voot.jpeg","vrotttv.jpeg",
      "disneyplus.jpeg","distrotv.jpeg","hoichoi.jpeg",
      "mxplayer.jpeg","ottplay.jpeg","playfix.jpeg"
    ],

    "News": [
      "aajtak.jpeg","asianetnews.jpeg","bharatsamachar.jpeg",
      "cnnnews18.jpeg","ddnews.jpeg","indiatoday.jpeg",
      "ndtv.jpeg","news7.jpeg","polimernews.jpeg",
      "rajnews.jpeg","sunnews.jpeg","thanthitv.jpeg",
      "timesnow.jpeg","publictv.jpeg"
    ],

    "Kids": [
      "cartoonchannel.jpeg","chuttitv.jpeg",
      "pogo.jpeg","powerkids.jpeg"
    ],

    "Sports": [
      "starsports1tamil.jpeg","sports18png.png",
      "ptcplay.jpeg"
    ],

    "TV Channels": [
      "suntv.jpeg","vijaytv.jpeg","zeetamil.jpeg",
      "ktv.jpeg","vasanthtv.jpeg","kalaingartvjpg.jpg",
      "colortamiljpg.jpg","maalimalar.jpeg","sathiyamtv.jpeg",
      "puthiya.jpeg","R.jpeg","runnutv.jpeg"
    ],

    "Discovery / Docs": [
      "discovery+.jpeg","shortfundly.jpeg","dollywoodplay.jpeg"
    ]
  };

  return (
    <div className="ottPage">

      {Object.keys(categories).map((cat,i)=>(

        <div key={i} className="catBlock">

          <h3 className="catTitle">{cat}</h3>

          <div className="ottGrid">
            {categories[cat].map((logo, j) => (
              <div key={j} className="ottBox" tabIndex="0">

                <img src={`/allott/${logo}`} alt={logo} />

                <div className="ottName">
                  {logo.replace(".jpeg","")
                       .replace(".png","")
                       .replace(".jpg","")}
                </div>

              </div>
            ))}
          </div>

        </div>
      ))}

      {/* STYLE */}
      <style>{`

/* PAGE */
.ottPage{
  padding:40px 60px;
}

/* CATEGORY BLOCK */
.catBlock{
  margin-bottom:80px;
}

/* CATEGORY TITLE */
.catTitle{
  margin:0 0 35px;
  font-size:26px;
  letter-spacing:2px;
  color:#fff;
  text-align:center;
  font-weight:600;
  position:relative;
  text-shadow:0 0 15px rgba(229,9,20,.7);
}

/* UNDERLINE */
.catTitle::after{
  content:"";
  width:90px;
  height:3px;
  background:#e50914;
  display:block;
  margin:12px auto 0;
  border-radius:10px;
  box-shadow:0 0 18px #e50914;
}

/* GRID */
.ottGrid{
  display:grid;
  grid-template-columns:repeat(auto-fill,minmax(160px,1fr));
  gap:45px;
  justify-items:center;
}

/* ROUND CARD */
.ottBox{
  width:145px;
  height:145px;
  border-radius:50%;
  background: radial-gradient(circle at top,#2e2e2e,#000);
  display:flex;
  align-items:center;
  justify-content:center;
  transition:.35s ease;
  cursor:pointer;
  position:relative;
}

/* IMAGE */
.ottBox img{
  width:95px;
  height:95px;
  object-fit:cover;
  border-radius:28px;
  padding:6px;
  background:#000;
  filter:brightness(1.15) contrast(1.15);
  transition:.35s;
  box-shadow:
    0 0 12px rgba(255,255,255,.35),
    inset 0 0 10px rgba(255,255,255,.2);
}

/* NAME */
.ottName{
  position:absolute;
  bottom:-28px;
  font-size:13px;
  opacity:0;
  color:#fff;
  transition:.3s;
  text-transform:capitalize;
}

/* HOVER */
.ottBox:hover{
  transform:scale(1.18);
  box-shadow:
    0 0 25px rgba(255,255,255,.35),
    0 0 70px rgba(229,9,20,.35);
}

.ottBox:hover img{
  filter:brightness(1.3) contrast(1.2);
}

.ottBox:hover .ottName{
  opacity:1;
  bottom:-20px;
}

/* TV REMOTE FOCUS */
.ottBox:focus{
  outline:none;
  transform:scale(1.22);
  box-shadow:
    0 0 35px #e50914,
    0 0 90px rgba(229,9,20,.7);
}

      `}</style>

    </div>
  );
}
